import { render, staticRenderFns } from "./NeedToContactCard.vue?vue&type=template&id=09bef9e4&scoped=true"
import script from "./NeedToContactCard.vue?vue&type=script&lang=ts"
export * from "./NeedToContactCard.vue?vue&type=script&lang=ts"
import style0 from "./NeedToContactCard.vue?vue&type=style&index=0&id=09bef9e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bef9e4",
  null
  
)

export default component.exports